import { useEffect, useRef } from 'react'

/**
 * Añade la clase `is-visible` al elemento cuando entra en el viewport.
 * Reemplaza las animaciones de scroll de framer-motion con un solo
 * IntersectionObserver por sección (coste casi nulo en el bundle).
 */
export function useReveal<T extends HTMLElement = HTMLDivElement>(rootMargin = '0px 0px -10% 0px') {
  const ref = useRef<T | null>(null)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    if (typeof IntersectionObserver === 'undefined') {
      node.classList.add('is-visible')
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin, threshold: 0.15 },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [rootMargin])

  return ref
}
